import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string) || "https://us.i.posthog.com";

let initialized = false;

export function initPostHog() {
  if (initialized || !POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    persistence: "localStorage+cookie",
  });
  initialized = true;
}

// Funnel events
export const track = {
  /** LP visited */
  landingViewed: () => posthog.capture("landing_viewed"),

  /** User signed up via GitHub OAuth */
  signedUp: (userId: number, login: string) => {
    posthog.identify(String(userId), { login });
    posthog.capture("signed_up", { login });
  },

  /** User connected a GitHub App (repos enabled) */
  repoConnected: (repoCount: number) => {
    posthog.capture("repo_connected", { repo_count: repoCount });
  },

  /** First analysis triggered */
  analysisTrigger: (org: string, type: "repo" | "org") => {
    posthog.capture("analysis_triggered", { org, type });
  },

  /** Analysis completed successfully */
  analysisCompleted: (org: string) => {
    posthog.capture("analysis_completed", { org });
  },

  /** Dashboard (Observatory) viewed */
  dashboardViewed: (org: string) => {
    posthog.capture("dashboard_viewed", { org });
  },

  /**
   * A paywall was HIT — the user reached a plan gate (a 402 wall or a lock
   * teaser). This is the conversion moment the funnel was missing: activation
   * events (signup → repo → analysis → dashboard) were tracked, but not the
   * point where a free user meets the wall. Pairing `paywall_hit` with
   * `upgrade_clicked` measures wall → click → paid, and — as importantly — the
   * drop-off at each step. `gate` names the wall (seat, nova_org, pro_deepdive,
   * chronicle, repo_limit, observation_quota); `plan` is the user's current plan.
   */
  paywallHit: (gate: string, plan?: string) => {
    posthog.capture("paywall_hit", { gate, plan });
  },

  /** Upgrade button clicked */
  upgradeClicked: (plan: string) => {
    posthog.capture("upgrade_clicked", { plan });
  },

  /** Onboarding completed */
  onboardingCompleted: () => {
    posthog.capture("onboarding_completed");
  },

  /**
   * An observation was marked useful — Ace's truest KPI is DISCOVERY, not
   * activity. This is the signal that an observation actually landed: the user
   * found it interesting, surprising, or actionable. Kept deliberately simple
   * (one event), with no scoring/ranking layered on top.
   */
  observationUseful: (kind: string, target: string, galaxy?: string) => {
    posthog.capture("observation_useful", { kind, target, galaxy });
  },
};
